import { Skeleton } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { authService } from "../../services";
import { addWatermark } from "../../utls/FunctionsUtil";
import { generateImageAltText } from "../../utls/imageAltGenerator";
import VideoPlayer from "../VideoPlayerComponent";
import "./index.less";

const FALLBACK_IMAGE = 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22400%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%232a2a2a%22%2F%3E%3Ctext%20x%3D%2250%25%22%20y%3D%2250%25%22%20font-family%3D%22sans-serif%22%20font-size%3D%2220%22%20text-anchor%3D%22middle%22%20fill%3D%22%23888%22%20dy%3D%22.3em%22%3EMedia%20Unavailable%3C%2Ftext%3E%3C%2Fsvg%3E';

type props = {
  shouldAddWatermark?: boolean;
  fileUrl: string;
  thumbnail: string;
  description: string;
  type: string;
  imageClassName: string;
  isPrivate: boolean;
  isMyProfile: boolean;
  profileName?: string;
  username?: string;
  feedIndex?: number;
  feedId?: string;
  isVideo?: boolean;
};

const FeedMediaComponent: React.FC<props> = ({
  shouldAddWatermark = true,
  fileUrl,
  thumbnail,
  description,
  type,
  imageClassName,
  isPrivate,
  isMyProfile,
  profileName,
  username,
  feedIndex,
  feedId,
  isVideo = false,
}) => {
  const imgUrl = type === "video" ? thumbnail : fileUrl;
  const [watermarkedImageUrl, setWatermarkedImageUrl] = useState<string>(shouldAddWatermark && !isPrivate ? "" : imgUrl);
  const [hasError, setHasError] = useState<boolean>(false);

  const altText = useMemo(
    () =>
      generateImageAltText({
        name: profileName,
        username: username,
        index: feedIndex,
        id: feedId,
        fallback: "publication",
        isVideo: isVideo,
      }),
    [profileName, username, feedIndex, feedId, isVideo]
  );

  useEffect(() => {
    setHasError(false);
    if (shouldAddWatermark && !isPrivate && !isMyProfile) {
      addWatermark(imgUrl, authService.getUser().username)
        .then((newImageUrl) => {
          setWatermarkedImageUrl(newImageUrl);
        })
        .catch((err) => {
          console.log("Error generating watermarked image:", err);
          setWatermarkedImageUrl(imgUrl);
        });
    } else {
      setWatermarkedImageUrl(imgUrl);
    }
  }, [fileUrl, thumbnail, type, shouldAddWatermark, isPrivate, isMyProfile]);

  if (watermarkedImageUrl === "" && shouldAddWatermark && !isPrivate) {
    return (
      <div className="fhp-main-skelton">
        <Skeleton.Image className="fhp-skelton-bg" active style={{ width: "100%", height: 450 }} />
      </div>
    );
    /* return (
      <div className={"d-flex justify-content-center items-center h-full"}>
        <LoadingOutlined style={{ color: "white", fontSize: "100px" }} />
      </div>
    ); */
  }

  if (type === "video") {
    if (fileUrl !== "" && thumbnail !== "") {
      return <VideoPlayer videoUrl={fileUrl!} thumbnailUrl={watermarkedImageUrl!} />;
    }
  }

  return <img className={imageClassName} src={hasError ? FALLBACK_IMAGE : watermarkedImageUrl} alt={altText} title={altText} onError={() => setHasError(true)} />;
};

export default FeedMediaComponent;
